import {
  Box,
  Button,
  Center,
  Radio,
  Text,
  Stack,
  ActionIcon,
} from "@mantine/core";
import { useState } from "react";
import useStyles from "./style";
import { useSelector } from "react-redux";
import { PhoneInput } from "react-international-phone";
import { IconEdit, IconCheck } from "@tabler/icons-react";
import { useLocation, useNavigate } from "react-router-dom";
import { send2faCodeSkypoint } from "../../services";
import { obfuscateEmail, obfuscatePhone } from "../../utils";

const SkypointSelectTwoFactorMethod = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const user = location?.state?.user;
  // Issued by /auth/skypoint/login in place of a session token (OD-1482).
  const pendingToken = location?.state?.pendingToken;

  const [selectedMethod, setSelectedMethod] = useState(null);
  const [phone, setPhone] = useState(user?.phone || "");
  const [isEditingPhone, setIsEditingPhone] = useState(false);
  const [isPhoneSaved, setIsPhoneSaved] = useState(!!user?.phone);
  const [sending, setSending] = useState(false);


  const sms2faEnabled = user?.sms2FaEnabled;
  const email2faEnabled = user?.email2FaEnabled;

  if (!user) {
    navigate("/skypoint-login");
    return null; // Stop rendering
  }

  const handlePhoneEdit = (e) => {
    e.stopPropagation();
    setIsEditingPhone(true);
    setIsPhoneSaved(false);
  };

  const handleSavePhone = (e) => {
    e.stopPropagation();
    setIsEditingPhone(false);
    setIsPhoneSaved(true);
  };

  const handleSelectMethod = (method) => {
    setSelectedMethod(method);

    if (method === "phone") {
      if (!user?.phone) {
        setIsEditingPhone(true);
        setIsPhoneSaved(false);
      }
    } else {
      setIsEditingPhone(false);
      setIsPhoneSaved(!!user?.phone);
      setPhone(user?.phone || "");
    }
  };

  const showPhoneInput = selectedMethod === "phone" && isEditingPhone;

  const isContinueDisabled =
    !selectedMethod ||
    (selectedMethod === "phone" && (!isPhoneSaved || !phone));

  const handleSave = async () => {
    try {
      setSending(true);
      const payload = {
        otpType: selectedMethod === "phone" ? "sms" : "email",
        userId: user?.id,
        phone: selectedMethod === "phone" ? phone : undefined,
        pendingToken,
      };
      await send2faCodeSkypoint(payload, navigate);
    } catch (error) {
    } finally {
      setSending(false);
    }
  };

  return (
    <Center className={classes.container}>
      <Box className={classes.card}>
        <Text className={classes.title}>Two-step authentication</Text>
        <Text className={classes.subtitle}>
          Select a two-step authentication method
        </Text>

        <Stack spacing="md">
          {/* --- EMAIL OPTION (non-editable) --- */}
          {email2faEnabled && (
            
          
          <Box
            className={`${classes.radioBox} ${
              selectedMethod === "email" ? classes.radioBoxSelected : ""
            }`}
            onClick={() => handleSelectMethod("email")}
          >
            <Radio
              value="email"
              color="orange"
              checked={selectedMethod === "email"}
              onClick={() => handleSelectMethod("email")}
              label={
                <Box>
                  <Text className={classes.radioLabel}>
                    Send a code to my email
                  </Text>
                  <Box>
                    <Text className={classes.radioDescription}>
                      {/* {user?.email || "No email found"} */}
                       {obfuscateEmail(user?.email)}
                    </Text>
                  </Box>
                </Box>
              }
              styles={{
                radio: { cursor: "pointer" },
                label: { cursor: "pointer", paddingLeft: "0.5rem" },
              }}
            />
          </Box>
          )}

          {/* --- PHONE OPTION (editable) --- */}
          {sms2faEnabled && (

          <Box
            className={`${classes.radioBox} ${
              selectedMethod === "phone" ? classes.radioBoxSelected : ""
            }`}
            onClick={() => handleSelectMethod("phone")}
          >
            <Radio
              color="orange"
              value="phone"
              checked={selectedMethod === "phone"}
              onClick={() => handleSelectMethod("phone")}
              label={
                <Box>
                  <Text className={classes.radioLabel}>
                    Send a code to my phone
                  </Text>
                  {!showPhoneInput && phone && (
                    <Box className={`${classes.phoneDisplayRow}`}>
                      <Text className={classes.radioDescription}>
                        {/* {phone} */}
                        {obfuscatePhone(phone)}
                        </Text>
                      {/* {selectedMethod === "phone" && (
                        <ActionIcon
                          size="sm"
                          className={classes.editIcon}
                          onClick={handlePhoneEdit}
                        >
                          <IconEdit size={16} color="#FFAF4A" />
                        </ActionIcon>
                      )} */}
                    </Box>
                  )}
                </Box>
              }
              styles={{
                radio: { cursor: "pointer" },
                label: { cursor: "pointer", paddingLeft: "0.5rem" },
              }}
            />

            {/* Edit mode: input + save */}
            {/* {showPhoneInput && (
              <Box className={classes.phoneEditRow}>
                <PhoneInput
                  defaultCountry="us"
                  placeholder="Enter phone number"
                  value={phone}
                  onChange={(value) => setPhone(value)}
                  className={classes.phoneInputWrapper}
                  disableFormatting={false}
                  forceDialCode={true}
                  showDisabledDialCode={true}
                  autoFocus
                />
                <Box className={classes.saveButton} onClick={handleSavePhone}>
                  <IconCheck size={18} />
                </Box>
              </Box>
            )} */}
          </Box>
          )}
        </Stack>

        <Button
          disabled={isContinueDisabled}
          className={classes.continueBtn}
          onClick={handleSave}
          loading={sending}
        >
          Send OTP
        </Button>
      </Box>
    </Center>
  );
};

export default SkypointSelectTwoFactorMethod;
